
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as historySaLsCneGF9Meta } from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/forecast/history.vue?macro=true";
import { default as resultnOZeqo0oKvMeta } from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/forecast/result.vue?macro=true";
import { default as indexKKqIueY94uMeta } from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/index.vue?macro=true";
import { default as registration_redirectAxtpjownnXMeta } from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/registration_redirect.vue?macro=true";
import { default as registrationvBOr6IIq63Meta } from "/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/registration.vue?macro=true";
export default [
  {
    name: "forecast-history",
    path: "/forecast/history",
    component: () => import("/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/forecast/history.vue")
  },
  {
    name: "forecast-result",
    path: "/forecast/result",
    component: () => import("/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/forecast/result.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/index.vue")
  },
  {
    name: "registration_redirect",
    path: "/registration_redirect",
    component: () => import("/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/registration_redirect.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/Users/taniha/work/git/BTOS-2.5WEB/CloudFormation/with-25web-season-web-weathernews/site/sakura_aicamera/pages/registration.vue")
  }
]